import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './common/image/profile-logo.png';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { formatAddress } from 'utils/help/formatAddress';
import { Resolver } from './utils/canister/Resolver';
import { IC_RESOLVER_ID, ICP_RESOLVER_ID } from 'utils/config/canisterIds';
import ImageLoad from 'component/ImageLoad';
import { isLocalEnv } from 'utils/config';
import { CryptoIcon } from 'component/CryptoIcon';

const App = () => {
    const notify = (str: string) => {
        navigator.clipboard.writeText(str)
        toast("Success clipboard", {
            autoClose: 2000,
        });
    }
    const [loading, setLoading] = useState(true);
    const [isDesktop, setIsDesktop] = useState(true);
    const [name, setName] = useState('');
    const [recordsText, setRecordsText] = useState([
        { title: 'BTC', key: 'token.btc', value:'Not set', type:'crypto'},
        { title: 'ETH', key: 'token.eth', value:'Not set', type:'crypto'},
        { title: 'BNB', key: 'token.bnb', value:'Not set', type:'crypto'},
        { title: 'XRP', key: 'token.xrp', value:'Not set', type:'crypto'},
        { title: 'ADA', key: 'token.ada', value:'Not set', type:'crypto'},
        { title: 'SOL', key: 'token.sol', value:'Not set', type:'crypto'},
        { title: 'DOGE', key: 'token.doge', value:'Not set', type:'crypto'},
        { title: 'DOT', key: 'token.dot', value:'Not set', type:'crypto'},
        { title: 'MATIC', key: 'token.matic', value:'Not set', type:'crypto'},
        { title: 'TRX', key: 'token.trx', value:'Not set', type:'crypto'},
        { title: 'AVAX', key: 'token.avax', value:'Not set', type:'crypto'},
        { title: 'ETC', key: 'token.etc', value:'Not set', type:'crypto'},
        { title: 'LTC', key: 'token.ltc', value:'Not set', type:'crypto'},
        { title: 'XLM', key: 'token.xlm', value:'Not set', type:'crypto'},
        { title: 'XMR', key: 'token.xmr', value:'Not set', type:'crypto'},
        { title: 'ALGO', key: 'token.algo', value:'Not set', type:'crypto'},
        { title: 'BCH', key: 'token.bch', value:'Not set', type:'crypto'},
        { title: 'VET', key: 'token.vet', value:'Not set', type:'crypto'},
        { title: 'XTZ', key: 'token.xtz', value:'Not set', type:'crypto'},
        { title: 'AAVE', key: 'token.aave', value:'Not set', type:'crypto'},
        { title: 'BSV', key: 'token.bsv', value:'Not set', type:'crypto'},
        { title: 'ZEC', key: 'token.zec', value:'Not set', type:'crypto'},
        { title: 'BTT', key: 'token.btt', value:'Not set', type:'crypto'},
        { title: 'NEO', key: 'token.neo', value:'Not set', type:'crypto'},
        { title: 'DASH', key: 'token.dash', value:'Not set', type:'crypto'},
        { title: 'WAVES', key: 'token.waves', value:'Not set', type:'crypto'},
        { title: 'BTG', key: 'token.btg', value:'Not set', type:'crypto'},
        { title: 'XEM', key: 'token.xem', value:'Not set', type:'crypto'},
        { title: 'DCR', key: 'token.dcr', value:'Not set', type:'crypto'},
        { title: 'GNO', key: 'token.gno', value:'Not set', type:'crypto'},
        { title: 'ICP', key: 'principal.icp', value: "Not set", type: "crypto" },
        { title: 'ICP', key: 'account_id.icp', value: "Not set", type: "crypto" },
        { title: 'Display_name', key: 'display_name', value: "Not set", type: "intr" },
        { title: 'Description', key: 'description', value: "Not set", type: "intr" },
        { title: 'Avatar', key: 'avatar', value: logo, type: "intr" },
        { title: 'Email', key: 'email', value: "Not set", type: "intr" },
        { title: 'Location', key: 'location', value: "Not set", type: "intr" },
        { title: 'Twitter', key: 'com.twitter', value: "Not set", type: "social" },
        { title: 'Telegram', key: 'com.telegram', value: "Not set", type: "social" },
        { title: 'Openchat', key: 'com.openchat', value: "Not set", type: "social" },
        { title: 'Medium', key: 'com.medium', value: "Not set", type: "social" },
        { title: 'Instagram', key: 'com.instagram', value: "Not set", type: "social" },
        { title: 'Github', key: 'com.github', value: "Not set", type: "social" },
        { title: 'Facebook', key: 'com.facebook', value: "Not set", type: "social" },
        { title: 'Dscvr', key: 'com.dscvr', value: "Not set", type: "social" },
        // { title: 'District', key: 'com.district', value: "Not set", type: "social" },
        { title: 'Discord', key: 'com.discord', value: "Not set", type: "social" },
        { title: 'Calendly', key: 'com.calendly', value: "Not set", type: "social" },
        { title: 'Reddit', key: 'com.reddit', value: "Not set", type: "social" },
        { title: 'Relation', key: 'com.relation', value: "Not set", type: "social" },
        { title: 'Distrikt', key: 'com.distrikt', value: "Not set", type: "social" },
    ]);

    useEffect(() => {
        const url = window.location.href;
        const domain = isLocalEnv() ? ".localhost" : ".dance";
        const name = url.split(domain)[0].split('//')[1];
        setName(name)
    }, [window.location])

    const cyWindow = () => {
        window.innerWidth >= 768 ? setIsDesktop(true) : setIsDesktop(false);
    }
    useEffect(() => {
        cyWindow();
        window.addEventListener('resize', cyWindow);
    }, [window.innerWidth])

    const getData = async () => {
        setLoading(true);
        try {
            const RESOLVER_ID = name.indexOf('icp') !== -1 ? ICP_RESOLVER_ID : IC_RESOLVER_ID;
            const res = await new Resolver(RESOLVER_ID).getRecordValues(name);
            if (!res[0]) {
                toast('page not find', {
                    autoClose: 3000,
                });
                setInterval(() => window.location.href = `https://app.icnaming.com/#/search/${name}`, 3000)
                return;
            }
            const records = recordsText.map(item => {
                const record = res.find(record => record[0] === item.key);
                return record ?
                    { ...item, value: record[1] }
                    :
                    { ...item, type: "none" };
            })
            console.log(records)
            setRecordsText(records);
        } catch (error) {
            console.log(error.message)
            toast(error.message, {
                autoClose: 2000,
            });
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        const timeout = setTimeout(() =>
            getData(), 300);
        return () => clearTimeout(timeout);
    }, [name !== ''])

    const renderIcp = () => {
        const principal = recordsText.find(({ key }) => key === 'principal.icp').value;
        const account_id = recordsText.find(({ key }) => key === 'account_id.icp').value;
        return (
            principal !== 'Not set' || account_id !== 'Not set' ?
                <div className="crypto-wrap">
                    <div className="symbol">
                        <CryptoIcon name="ICP" />ICP
                    </div>
                    <div className="icp-address">
                        {
                            principal !== 'Not set' && <div className="address">
                                <b className="badge">Principal</b>
                                {isDesktop ? principal : formatAddress(principal)}
                                <button onClick={() => notify(principal)} className="btn-copy" />
                            </div>
                        }
                        {
                            account_id !== 'Not set' && <div className="address">
                                <b className="badge badge-account">Account</b>
                                {isDesktop ? account_id : formatAddress(account_id)}
                                <button onClick={() => notify(account_id)} className="btn-copy" />
                            </div>
                        }
                    </div>
                </div> : null
        )
    }

    return (
        <div className="container">
            <div className="box intr">
                <div className="logo">
                    {
                        recordsText.find(t => t.key === 'avatar').value !== logo ?
                            <ImageLoad srcAddress={recordsText.find(t => t.key === 'avatar').value} alt={name} />
                            :
                            <img src={logo} alt={name} />
                    }
                </div>
                <dl className="intr-dl">
                    <dt className="intr-title">{recordsText.find(t => t.key === 'display_name').value}</dt>
                    <dd className="intr-info">
                        <span><i className="icon icon-local" />{recordsText.find(t => t.key === 'location').value}</span>
                        <span><i className="icon icon-email" />{recordsText.find(t => t.key === 'email').value}</span>
                    </dd>
                    <dd className="description">{recordsText.find(t => t.key === 'description').value}</dd>
                </dl>
            </div>

            <h2 className="title">Socials</h2>
            <div className="box socials">
                {
                    recordsText.filter(({ type, value }) => type === 'social' && value !== 'Not set').length > 0 ?
                        recordsText.filter(({ type }) => type === 'social')
                            .map(({ key, title, value }) => <a href={value} key={key}><i className={classNames("icon", `icon-${title.toLocaleLowerCase()}`)} /></a>)
                        :
                        <div className="no-social">Not set</div>
                }
            </div>

            <h2 className="title">Crypto Addresses</h2>
            <div className="box addresses-wrap">
                {
                    recordsText.filter(({ type }) => type === 'crypto').length > 0 ?
                        <>
                            {
                                recordsText.filter(({ title, type }) => type === 'crypto' && title !== 'ICP').map(({ title, key, value }) =>
                                    <div className="crypto-wrap" key={key}>
                                        <div className="symbol">
                                            <CryptoIcon name={title} />{title}
                                        </div>
                                        <div className="address">
                                            {isDesktop ? value : formatAddress(value)}
                                            <button onClick={() => notify(value)} className="btn-copy" />
                                        </div>
                                    </div>)
                            }
                            {renderIcp()}
                        </>
                        :
                        <div className="no-social">Not set</div>
                }
            </div>
            {
                loading &&
                <div className="fullLoading">
                    <svg className="spinner" viewBox="0 0 50 50">
                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                    </svg>
                </div>
            }
            <ToastContainer />
        </div>
    )
}
export default App;